import { section } from "scmp-app/data";

export const StyleMainSectionPath = [section.magazine.entityId, section.style.entityId];

export const MagazinesStyleVariant = "magazines-style";
export type TypeMagazinesStyleVariant = typeof MagazinesStyleVariant;
